import { mascaraNumeracaoPtBr } from '../../../../_core/masks';
import { Guia } from '../types';

export type GuiaPagamentoMask = {
  id: number;
  comprovantePagamento: boolean;
  valor: string;
  numeroPO: string;
  numeroChamadoPagamento: string;
  numeroChamadoAjuizamento: string;
  statusChamadoAjuizamento: string;
  numeroProtocolo: string;
  dataAjuizamento: string;
};

const convertFromDatabaseDate = (date: string): string => {
  const arr = date.split('-');
  return `${arr[2]}/${arr[1]}/${arr[0]}`;
};

export const convertToDatabaseDate = (date: string): string => {
  const arr = date.split('/');
  return `${arr[2]}-${arr[1]}-${arr[0]}`;
};

export const convertGuiasPagamentoMask = (guias: Guia[]): GuiaPagamentoMask[] => {
  return guias.map(e => ({
    id: e.id,
    comprovantePagamento: e.comprovantePagamento,
    numeroPO: e.numeroPO ?? '',
    numeroChamadoPagamento: e.numeroChamadoPagamento ?? '',
    numeroChamadoAjuizamento: e.numeroChamadoAjuizamento ?? '',
    statusChamadoAjuizamento: e.statusChamadoAjuizamento ?? '',
    numeroProtocolo: e.numeroProtocolo ?? '',
    valor: e.valor
      ? e.valor.toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : '',
    dataAjuizamento: e.dataAjuizamento ? convertFromDatabaseDate(e.dataAjuizamento) : '',
  }));
};

export const STATUS_OPTIONS = [
  { value: 1, label: 'NAO_RESOLVIDO' },
  { value: 2, label: 'EM_ATENDIMENTO' },
  { value: 3, label: 'CANCELADO' },
  { value: 4, label: 'RESOLVIDO' },
];
export type FASE =
  | 'Documentação'
  | 'Guia de Pagamento'
  | 'PO'
  | 'Chamado para Pagamento'
  | 'Comprovantes de Pagamento'
  | 'Chamado para Ajuizamento'
  | 'Ação Ajuizada';

export const FASES_MAP = new Map<FASE, number>([
  ['Documentação', 1],
  ['Guia de Pagamento', 2],
  ['PO', 3],
  ['Chamado para Pagamento', 4],
  ['Comprovantes de Pagamento', 5],
  ['Chamado para Ajuizamento', 6],
  ['Ação Ajuizada', 7],
]);
